module.exports = __webpack_public_path__ + "static/455dba73-bf8f-47bc-aadb-1beb6639eb46-500.ed7c4b07.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/objects/banjoVase-cinnamon/455dba73-bf8f-47bc-aadb-1beb6639eb46-500.jpg
// module id = 866
// module chunks = 168707334958949